import { Tag } from 'antd'

const STATUS_COLORS: Record<string, string> = {
  // Active/success states
  launched: 'green',
  active: 'green',
  synced: 'green',
  ready: 'green',
  registered: 'green',
  completed: 'green',
  // Error states
  failed: 'red',
  frozen: 'red',
  aml_failed: 'red',
  // Neutral/terminal states
  terminated: 'default',
  canceled: 'default',
  expired: 'default',
  // Pending states
  pending: 'orange',
  launching: 'orange',
  creating: 'orange',
  new: 'orange',
  created: 'orange',
}

interface Props {
  status: string
  colorMap?: Record<string, string>
}

export function StatusTag({ status, colorMap }: Props) {
  const color =
    colorMap?.[status] ?? STATUS_COLORS[status.toLowerCase()] ?? 'default'
  return <Tag color={color}>{status}</Tag>
}
